export default {
    formId: 'cotizarForm',
    formField: {
        afinidad: {
            name: 'afinidad',
            label: 'Afinidad',
            requiredErrorMsg: 'Debe especificar la afinidad a la que pertenece el titular'
        },
        img_afinidad:{
            name: 'img_afinidad',
            label: 'img_afinidad',
        },
        vehiculo: {
            marca: {
                name: 'vehiculo.marca',
                label: 'Marca',
                requiredErrorMsg: 'Debe especificar la marca del vehículo'
            },
            modelo: {
                name: 'vehiculo.modelo',
                label: 'Modelo',
                requiredErrorMsg: 'Debe especificar el modelo del vehículo'
            },
            anio: {
                name: 'vehiculo.anio',
                label: 'Año',
                requiredErrorMsg: 'Debe especificar el año del vehículo'
            },
            version: {
                name: 'vehiculo.version',
                label: 'Versión',
                requiredErrorMsg: 'Debe especificar la versión del vehículo'
            },
            esCeroKm: {
                name: 'vehiculo.ceroKm',
                label: '¿0 Km?'
            },
            tieneGnc: {
                name: 'vehiculo.tieneGnc',
                label: '¿Tiene equipo de GNC?',
                requiredErrorMsg: ''
            },
            sumaAsegurada: {
                name: 'sumaAsegurada',
                label: 'Suma asegurada*',
                requiredErrorMsg: 'Debe indicar la suma asegurada'
            },
            sumaAseguradaGnc: {
                name: 'vehiculo.valorGnc',
                label: 'Valor del equipo de GNC',
                requiredErrorMsg: 'Debe ingresar la suma asegurada del equipo de GNC'
            },
            sumaAseguradaAdicional: {
                name: 'vehiculo.valorAdicional',
                label: 'Valor adicional (accesorios)',
                requiredErrorMsg: 'Debe especificar un valor (puede ser cero)'
            },
            usoVehiculo: {
                name: 'vehiculo.usoVehiculo',
                label: 'Tipo de uso',
                requiredErrorMsg: ''
            },
        },
        situacionImpositiva: {
            name: 'situacionImpositiva',
            label: 'Situación impositiva*',
            requiredErrorMsg: 'Debe seleccionar una opción'
        },
        personaJuridica: {
            name: 'personaJuridica',
            label: 'Persona jurídica*',
            requiredErrorMsg: 'Debe seleccionar una opción'
        },
        codigosLocalidad: {
            name: 'codigosLocalidad',
            label: 'Código postal / Localidad*',
            requiredErrorMsg: 'Debe especificar una localidad'
        },
        vigencia: {
            name: 'vigencia',
            label: 'Vigencia*',
            requiredErrorMsg: 'Debe seleccionar una opción'
        },
        fechaVigencia: {
            name: 'fechaVigencia',
            label: 'Desde',
            requiredErrorMsg: 'Debe especificar una fecha'
        },
        descuentoExtra: {
            name: 'descuentoExtra',
            label: 'Porcentaje de Descuento',
            requiredErrorMsg: 'Debe especificar un porcentaje de descuento'
        },
        descuentoEspecial: {
            name: 'descuentoEspecial',
            label: 'Descuento especial',
            requiredErrorMsg: 'Debe especificar un porcentaje de descuento'
        },
        frecuenciaPago: {
            name: 'frecuenciaPago',
            label: 'Frecuencia de pago*',
            requiredErrorMsg: 'Debe seleccionar una opción'
        },
        cuotas: {
            name: 'cuotas',
            label: 'Cantidad de cuotas*',
            requiredErrorMsg: 'Debe seleccionar una opción'
        },
        ajusteAutomatico : {
            name: 'ajusteAutomatico',
            label: 'Ajuste automático',
            requiredErrorMsg: 'Debe seleccionar una opción'
        },
        equipoTelematica : {
            name: 'equipoTelematica',
            label: 'Equipo telemática',
            requiredErrorMsg: 'Debe seleccionar una opción'
        },
        carProdSelected : {
            name: 'carProdSelected',
            requiredErrorMsg: 'Debe seleccionar una opción'
        },
        comments: {
            name: 'comments',
        },
        uploadedFile: {
            name: 'uploadedFile',
        },
        fechaCotizacion: {
            name: 'fechaCotizacion',
            label: 'Fecha de cotización*',
            requiredErrorMsg: 'Debe indicar la fecha de cotización'
        },
        zonaRiesgo: {
            name: 'zonaRiesgo',
            label: 'Zona de riesgo',
        }
    }
};
